import { AdvizeoTooltipDirective } from '@/directives/advizeo-tooltip/advizeo-tooltip.directive';
import { TrackClickDirective } from '@/directives/track-click/track-click.directive';
import { type ColorPalette, designSystemColorPalettes } from '@/shared/ui/theming';
import { type IconName, UiIconComponent } from '@/ui/icon/ui-icon';
import { ChangeDetectionStrategy, Component, forwardRef, input, model, signal } from '@angular/core';
import { type ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface UiButtonToggleOption {
    code: CodeType;
    label: string;
    icon?: IconName;
    hint?: string;
    disabled?: boolean;
    trackClick?: string;
}

type CodeType = any;

@Component({
    styleUrls: ['./ui-button-toggle.component.scss'],
    selector: 'ui-button-toggle',
    templateUrl: 'ui-button-toggle.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UiButtonToggleComponent),
            multi: true
        }
    ],
    imports: [UiIconComponent, AdvizeoTooltipDirective, TrackClickDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiButtonToggleComponent implements ControlValueAccessor {
    colorPalette = input<ColorPalette>(designSystemColorPalettes.default);

    options = input<UiButtonToggleOption[]>([]);
    disabled = model(false);

    private onChange: (newValue: CodeType | null) => void = () => {};
    private onTouch: () => void = () => {};

    currentValue = signal<CodeType | null>(null);

    optionSelected(optionCode: CodeType | null) {
        this.onChange(optionCode);
        this.onTouch();
        this.currentValue.set(optionCode);
    }

    writeValue(value: CodeType | null) {
        this.currentValue.set(value);
    }

    registerOnChange(fn: (newValue: CodeType) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouch = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled.set(isDisabled);
    }
}
